<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      rerender: true,
      d_check: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn]) == this.item.displayOnValue
          : this.selectedItem[this.item.displayOn] == this.item.displayOnValue
        : false,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    cqcRatingMap() {
      return {
        "Outstanding": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/outstanding-badge.png",
        "Good": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/Good+badge.png",
        "Requires improvement": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/requries-improvement-badge.png",
        "Inadequate": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/inadequate-badge.png",
        "Not rated": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/not-rated-badge.png"
      };
    },
    badgeUrl() {
      const rating = this.selectedItem?.additionalProp1?.cqc_option;
      const url = this.cqcRatingMap[rating] || "";
      console.log("CQC Badge URL:", { rating, url });
      return url;
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    // Watch for CQC rating changes
    'selectedItem.additionalProp1.cqc_option': {
      handler(newVal, oldVal) {
        console.log("CQC rating changed:", { oldVal, newVal });
        this.rerender = false;
        this.$nextTick(() => {
          this.rerender = true;
        });
      },
      deep: true,
    },
  },
  mounted() {
    console.log("CqcPreview mounted", {
      item_key: this.item_key,
      item: this.item,
      selectedItem: this.selectedItem,
      d_check: this.d_check,
      display_none_check: this.display_none_check
    });
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{
      'd-none': item.displayOn && !display_none_check,
    }"
  >
    <Label
      v-if="!item.hideLabel"
      :item="item"
      :model_length="validation.$model.length"
    />
    <div class="cqc-preview-container" v-if="rerender" :key="badgeUrl">
      <img
        v-if="badgeUrl"
        :src="badgeUrl"
        alt="CQC Rating Badge"
        class="cqc-badge-img"
        @error="console.error('CQC Badge failed to load:', badgeUrl)"
      />
      <div v-else class="text-muted small">
        Select a CQC rating to preview the badge
      </div>
    </div>
  </div>
</template>

<style scoped>
.cqc-preview-container {
  padding: 10px 0;
}

.cqc-badge-img {
  max-width: 150px;
  max-height: fit-content;
  object-fit: contain;
}
</style>
